(() => {
  if (customElements.get('aa-reviews')) return;
  customElements.define('aa-reviews', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.AaReviews__track');
      this.cards = [...this.track.children];
      this.buttons = [...this.querySelectorAll('button')];
      this.events = new AbortController();
      this.querySelector('.AaReviews__controls').hidden = false;
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const step = this.cards[1] ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : this.track.clientWidth;
        const count = Math.max(1, Math.floor((this.track.clientWidth + 24) / step));
        this.track.scrollBy({ left: step * count * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal: this.events.signal }));
      this.track.addEventListener('scroll', () => this.update(), { signal: this.events.signal, passive: true });
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    update() {
      const bounds = this.track.getBoundingClientRect();
      const visible = this.cards.map((card, index) => ({ index, rect: card.getBoundingClientRect() }))
        .filter(({ rect }) => rect.left >= bounds.left - 2 && rect.left < bounds.right - 30);
      const first = visible[0]?.index ?? 0;
      const last = visible.at(-1)?.index ?? first;
      this.querySelector('.AaReviews__progress').textContent = `${first + 1}${last > first ? '–' + (last + 1) : ''} of ${this.cards.length} reviews`;
      this.buttons[0].disabled = this.track.scrollLeft < 2;
      this.buttons[1].disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
    }
    disconnectedCallback() { this.events?.abort(); this.resize?.disconnect(); }
  });
})();
